import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LoadingScreen } from "./LoadingScreen";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  
  if (loading) return <LoadingScreen />;
  if (!user) {
    // Pass the current location so login can redirect back after auth
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
};
